<template>
    <div id="Reported" style="min-height: inherit; display: flex; flex-direction: column;">
        <Header title="Payroll Self-Reporting"/>
            <div class="mainbody">
                <div id="content">
                    <h2>Payroll Period: <span>{{ reporting.payrollPeriodStart }} - {{ reporting.payrollPeriodEnd }}</span></h2>
                    <ErrorList v-if="error" :error="error"/>
                    <div class="bracket-green">
                        <p v-if="inPeriodAndReported()">You have already <router-link :to="{ name: 'PaymentHistory' }">reported</router-link> payroll for the month of {{ reportingPeriod() }}. Your premium will be withdrawn on the 15th. If you have incorrectly reported payroll for this period, please contact your Account Manager at <a href="tel:+18447618400">844-761-8400</a>. The next self-reporting period will be {{ nextPeriodStart() }} - {{ nextPeriodEnd() }}.</p>
                        <p v-else-if="missedReporting()">You did not report payroll for the month of {{ reportingPeriod() }}. An estimated payment will be withdrawn on the 15th. For assistance, contact your Account Manager at <a href="tel:+18447618400">844-761-8400</a>.</p>
                        <p v-else-if="pastReporting()">The next self-reporting period will will be {{ nextPeriodStart() }} - {{ nextPeriodEnd() }}. View <router-link :to="{ name: 'PaymentHistory' }">your payment history</router-link> for previous reports and invoices.</p>
                    </div>
                </div>
                <CompanyInfo/>
            </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'
import Header from './shared/Header'
import CompanyInfo from './shared/CompanyInfo'
import ErrorList from './shared/ErrorList'
import moment from 'moment'
import { create, reportingPeriod } from '@/utils/helpers'

export default {
    name: 'Reported',
    components: { Header, CompanyInfo, ErrorList },
    data() {
        return {
            current: {},
            error: null
        }
    },
    computed: {
        ...mapState([ 'contact', 'policies', 'reporting' ])
    },
    created() {
        create(this)
    },
    methods: {
        reportingPeriod() {
            return reportingPeriod(this.reporting.date)
        },
        nextPeriodStart() {
            let today = moment(this.reporting.date)
            if (today.date() >= 20) {
                return today.add(1, 'month').startOf('month').add(19, 'days').format('MM/DD/YYYY')
            } else {
                return today.startOf('month').add(19, 'days').format('MM/DD/YYYY')
            }
        },
        nextPeriodEnd() {
            let today = moment(this.reporting.date)
            let endDate = ''
            if (today.date() >= 20) {
                endDate = today.add(2, 'month').set('date', 10)
            } else {
                endDate = today.add(1, 'month').set('date', 10)
            }
            if (endDate.day() === 6) {
                endDate.add(2, 'day')
            } else if (endDate.day() === 0) {
                endDate.add(1, 'day')
            }
            return endDate.format('MM/DD/YYYY')
        },
        inPeriodAndReported() {
            let date = moment(this.reporting.date)
            if (date.date() >= 20 && this.hasReported()) {
                return true
            } else return date.date() <= 15 && this.hasReported();
        },
        missedReporting() {
            let reportingDate = moment(this.reporting.date)
            return !(this.hasReported()) && 13 <= reportingDate.date() && reportingDate.date() <= 15
        },
        pastReporting() {
            let date = moment(this.reporting.date)
            return date.date() > 15
        },
        hasReported(){
            return this.policies.filter(policy => !policy.hasReportedPayroll).length <= 0
        }
    }
}
</script>
